/** Adds mouse drag scrolling to compact rails while retaining native wheel and touch scrolling. */
export function enableRailDragScroll(root: HTMLElement): () => void {
  const cleanups = [...root.querySelectorAll<HTMLElement>('.scene-area-players, .scene-area-side')].map(rail => {
    let start: { id: number; x: number; y: number; left: number; top: number } | null = null;
    let dragged = false;
    const down = (event: PointerEvent) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      start = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, top: rail.scrollTop };
      dragged = false;
    };
    const move = (event: PointerEvent) => {
      if (!start || event.pointerId !== start.id) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      if (!dragged && Math.hypot(dx, dy) <= 6) return;
      if (!dragged) { dragged = true; rail.setPointerCapture(event.pointerId); rail.classList.add('is-dragging'); }
      rail.scrollLeft = start.left - dx;
      rail.scrollTop = start.top - dy;
      event.preventDefault();
    };
    const up = () => { start = null; rail.classList.remove('is-dragging'); };
    const click = (event: MouseEvent) => { if (dragged) { event.preventDefault(); event.stopPropagation(); dragged = false; } };
    rail.addEventListener('pointerdown', down);
    rail.addEventListener('pointermove', move);
    rail.addEventListener('pointerup', up);
    rail.addEventListener('pointercancel', up);
    rail.addEventListener('click', click, true);
    return () => { rail.removeEventListener('pointerdown', down); rail.removeEventListener('pointermove', move); rail.removeEventListener('pointerup', up); rail.removeEventListener('pointercancel', up); rail.removeEventListener('click', click, true); };
  });
  return () => cleanups.forEach(cleanup => cleanup());
}

/** A newly available tool may be below the fold; keep it in the rail without opening panels. */
export function revealFirstActiveTool(root: HTMLElement): void {
  const rail = root.querySelector<HTMLElement>('.scene-area-side');
  const tool = rail?.querySelector<HTMLElement>('.action-tile.is-selectable, .brick-panel .is-selectable');
  if (!rail || !tool || rail.clientHeight === 0) return;
  const pane = rail.getBoundingClientRect(), target = tool.getBoundingClientRect();
  if (target.top < pane.top || target.bottom > pane.bottom) tool.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}
